import script from "./UnidadeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./UnidadeSelector.vue?vue&type=script&setup=true&lang=js"

import "./UnidadeSelector.vue?vue&type=style&index=0&id=65f5aca8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f5aca8"]])

export default __exports__